import React from "react";
import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import { X } from "lucide-react";
import { BaseUnitForm } from "./BaseUnitForm";
import { CompositeUnitForm } from "./CompositeUnitForm";
import { TertiaryUnitForm } from "./TertiaryUnitForm";

export const EditUnitModal = ({ open, onClose, unit }) => {
  // Format the unit data for the form
  const formatUnitData = () => {
    const formattedData = {
      ...unit,
      id: unit._id || unit.id,
    };

    // Add specific fields based on unit type
    if (unit.type === "COMPOSITE") {
      formattedData.smallestUnit =
        unit.smallestUnitId || unit.smallestUnit?._id;
      formattedData.largerUnit = unit.largerUnitId || unit.largerUnit?._id;
      formattedData.conversionFactor = unit.conversionFactor;
    } else if (unit.type === "TERTIARY") {
      // Map fields according to the API response structure
      formattedData.smallestUnit =
        unit.smallestUnit?._id || unit.smallestUnitId;
      formattedData.largerUnit = unit.largerUnit?._id || unit.largerUnitId;
      formattedData.parentUnit = unit.largestUnit?._id || unit.largestUnitId;

      // Use the direct fields if available, otherwise calculate
      formattedData.unitsPerParent =
        unit.unitsPerParent || unit.conversionFactorForLargerUnit;
      formattedData.unitsPerMiddle =
        unit.unitsPerMiddle ||
        unit.conversionFactorForSmallestUnit /
          unit.conversionFactorForLargerUnit;
    }

    console.log("Formatted data for edit:", formattedData);
    return formattedData;
  };

  const renderForm = () => {
    const formattedData = formatUnitData();

    switch (unit.type) {
      case "BASE":
        return (
          <BaseUnitForm
            onClose={onClose}
            initialData={formattedData}
            isEditing={true}
          />
        );
      case "COMPOSITE":
        return (
          <CompositeUnitForm
            onClose={onClose}
            initialData={formattedData}
            isEditing={true}
          />
        );
      case "TERTIARY":
        return (
          <TertiaryUnitForm
            onClose={onClose}
            initialData={formattedData}
            isEditing={true}
          />
        );
      default:
        return <div>Unknown unit type</div>;
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "0.75rem",
          boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
        },
      }}>
      <DialogTitle className="flex items-center justify-between pr-2 pb-0">
        <h2 className="text-xl font-semibold text-gray-800 font-outfit">
          Edit {unit?.type?.toLowerCase()} Unit
        </h2>
        <IconButton onClick={onClose} size="small" className="text-gray-500">
          <X size={20} />
        </IconButton>
      </DialogTitle>
      <DialogContent className="mt-4">{renderForm()}</DialogContent>
    </Dialog>
  );
};
